// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// -- views
import PdfView from './PdfView';

export default class PdfViewer extends Component {

  static propTypes = {
    // String url or File object.
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

    httpHeaders: PropTypes.object,

    content: PropTypes.string,
    page: PropTypes.number,
    scale: PropTypes.number,
    loading: PropTypes.object
  };

  static defaultProps = {
    page: 1,

    scale: 1.0
  };

  state = {
    page: this.props.page,

    nbPages: null
  };

  // -- pdf loading
  onDocumentComplete = (nbPages) => {
    this.setState({
      nbPages
    });
  };

  onPageCompleted = (page) => {
    this.setState({ page });
  };

  // --

  onPreviousPage = () => {
    const newPageIndex = this.state.page - 1;

    if (newPageIndex <= 0) {
      return;
    }

    this.setState({
      page: newPageIndex
    });
  };

  onNextPage = () => {
    const newPageIndex = this.state.page + 1;

    if (newPageIndex > this.state.nbPages) {
      return;
    }

    this.setState({
      page: newPageIndex
    });
  };

  // -- renderers

  renderPagination() {
    // we are loading the pdf or there is only one page
    if (_.isNull(this.state.nbPages) || this.state.nbPages === 1) {
      return (null);
    }
    return (
      <div className="row pdf_viewer__pagination">

        <div
          className="col-xs-4 pagination__previous"
        >
          {this.state.page !== 1 &&
            <button
              className="btn"
              onClick={this.onPreviousPage}
            >
              <i className="fa fa-arrow-left" />
            </button>
          }
        </div>

        <div className="col-xs-4 pagination__page">
          {this.state.page} / {this.state.nbPages}
        </div>

        <div
          className="col-xs-4 pagination__next"
        >
          {this.state.page !== this.state.nbPages &&
            <button
              className="btn"
              onClick={this.onNextPage}
            >
              <i className="fa fa-arrow-right" />
            </button>
          }
        </div>
      </div>
    );
  }

  renderPdfView() {
    return (
      <PdfView
        file={this.props.file}
        page={this.state.page}
        scale={this.props.scale}
        httpHeaders={this.props.httpHeaders}
        onClick={this.onNextPage}
        onDocumentComplete={this.onDocumentComplete}
        onPageCompleted={this.onPageCompleted}
      />
    );
  }

  render() {
    return (
      <div className="pdf_viewer">
        {this.renderPagination()}
        {this.renderPdfView()}
      </div>
    );
  }

}
